import React, {useEffect, useState} from 'react';
import {Button, Modal, Switch} from 'antd';
import Batch from '../../http_request/Model/batch/Batch';
import {isLoading} from '../../store/TableRedux/TableRedux';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';


const ConfirmSwitch = ({disabled,
                           des = 'آیا از تغییر وضعیت اطمینان دارید؟',
                           rowData, address = 'batch/status',
                           title = 'تغییر وضعیت', defStatus,
                           checkedChildren = 'فعال', id = rowData?.id,
                           unCheckedChildren = 'غیر فعال',
                           hidden = false,
    showButton
                       }) => {
    const [checked, setChecked] = useState(defStatus);

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.TableRedux.loading);


    useEffect(() => {
        setChecked(defStatus)
    }, [defStatus]);

    const handleShow = () => {

        setOpen(true);

    };


    const handleOk = () => {

        const data = {
            'id': id,
            'status': !checked,
        };

        Batch.request({
            beforeSend: () => {
                dispatch(isLoading(true));
            }, success: (result) => {
                setChecked(!checked)
                setOpen(false)
                toast.success('درخواست شما با موفقیت انجام شد.');
            }, error: (error) => {
                toast.error(error.data.message);
            }, final: () => {
                dispatch(isLoading(false));
            },
        }).batchStatus(address, data);


    };


    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>
            {
                !hidden && <div onClick={handleShow}>

                    {
                        showButton ?


                            <Button disabled={disabled === 'disabled'}  className={`defBtn ${checked ?'blueBtn' : 'orangeBtn'}`}>{checked ? checkedChildren : unCheckedChildren}</Button>
                            :
                            <Switch disabled={disabled === 'disabled'}  checked={checked} unCheckedChildren={unCheckedChildren}
                                    className='bg-amber-600'
                                    checkedChildren={checkedChildren}/>
                    }

                </div>}

            <Modal
                open={open}
                title={title}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading} onClick={handleOk}>
                        ثبت
                    </Button>,

                ]}
            >
                <p>{des}</p>
            </Modal>
        </>

    );
};
export default ConfirmSwitch;